module.exports = __webpack_public_path__ + "img/hr-dry-hairy-tree-02.eadaf7d4.png";